<template>
  <div class="Chatroom" ref="panel">
    <van-nav-bar :title="title" fixed border @click-left="onClickLeft">
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" />
      </template>
    </van-nav-bar>
    <van-pull-refresh v-model="isloading" @refresh="reloadMoreMsg">
      <div id="content" ref="ref_content" :style="{height:scrollerHeight}">
        <van-loading v-if="videoFlag==true" type="spinner" color="#1989fa" />
        <template v-for="(item,index) in chatMessage" v-else>     
           <div :ref="'ref_msg_1'+item.m_id">
          <div v-if="item.m_type=='notice'" class="notice-content">{{item.m_post_messages}}</div>
          <!-- 右对齐 -->
            <van-row
              type="flex"
              justify="end"
              v-if="item.m_from_user_id == u_id && item.m_type!='notice'"
              :key="index+'a'"
              @click="selectOption(item.m_id,item.m_from_user_id,item.create_time,item.m_type,item.m_post_messages)"
            >
              <div :class="{'msg-box':flag}" :ref="'ref_msg_'+item.m_id">
                <van-image
                  class="err-image-header"
                  round
                  width="45px"
                  height="45px"
                  :src="attach_url+item.u_headportrait"
                />
                <van-col>
                  <div class="van-div-right">
                    <span class="time">{{item.create_time*1000|moment_format('M-D HH:mm')}}</span>
                  </div>
                  <div
                    :class="item.m_type=='video' || item.m_type == 'image' ?'entryimg2':'entry2'"
                  >
                    <div class="entry-trangle-right">
                      <!--本Div只来实现三角形，无其他作用-->
                    </div>
                    <span
                      v-if="item.m_type=='text'"
                      :class="[isUrl(item.m_post_messages) == true? 'span-url span-content':'span-content']"
                      :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
                      v-html="analyzeEmoji(item.m_post_messages)"
                      @click="CheckUrl(item.m_post_messages)"
                    ></span>
                    <span v-if="item.m_type=='audio'" class="span-content">
                      <div class="audio">
                        <audio controls="controls" :src="attach_url+item.m_post_messages"></audio>
                      </div>
                    </span>
                    <span v-if="item.m_type == 'video'" class="span1-content">
                      <!-- @click="showVideo(attach_url+item.m_post_messages)" -->
                      <!-- <van-loading v-if="videoFlag==true" type="spinner" color="#1989fa" /> -->
                      <div style="height:140px;width:200px">
                        <video
                          id="video"
                          style="height:140px;width:200px;object-fit:fill;"
                          controls="controls"
                          preload="auto"
                          poster="attach_url+videoImg"
                          :src="attach_url+item.m_post_messages"
                        ></video>
                      </div>
                    </span>
                    <van-image
                      v-if="item.m_type == 'image'"
                      class="err-image-img"
                      width="100"
                      :src="attach_url+item.m_post_messages"
                      @click.stop="showImage(attach_url+item.m_post_messages)"
                    />
                  </div>
                </van-col>
              </div>
            </van-row>
            <!-- 左对齐 -->
            <van-row
              type="flex"
              v-if="item.m_from_user_id != u_id && item.m_type!='notice'"
              :key="index+'a'"
              @click="selectOption(item.m_id,item.m_from_user_id,item.create_time,item.m_type,item.m_post_messages)"
            >
              <div class="msg-box" :class="{'msg-box':flag}" :ref="'ref_msg_'+item.m_id">
                <van-image
                  round
                  width="45px"
                  height="45px"
                  style="float:left"
                  class="err-image-header"
                  :src="attach_url+item.u_headportrait"
                  @click="headPortrait(item.u_id)"
                />
                <van-col>
                  <div class="van-div-left">
                    <span>{{item.u_name?item.u_name:item.u_nickname?item.u_nickname:item.u_login_id}}</span>
                    <span class="time">{{item.create_time*1000|moment_format('M-D HH:mm')}}</span>
                  </div>
                  <div
                    :class="item.m_type=='video' || item.m_type == 'image' ?'entryimg2':'entry1'"
                  >
                    <div class="entry-trangle-left">
                      <!--本Div只来实现三角形，无其他作用-->
                    </div>
                    <span
                      v-if="item.m_type=='text'"
                      :class="[isUrl(item.m_post_messages) == true? 'span-url span-content':'span-content']"
                      :style="{'font-size':(WindValue+'px'),'line-height':(WindValue+6+'px')}"
                      v-html="analyzeEmoji(item.m_post_messages)"
                      @click="CheckUrl(item.m_post_messages)"
                    >{{item.m_post_messages}}</span>
                    <span v-if="item.m_type=='audio'" class="span-content">
                      <audio controls="controls" :src="attach_url+item.m_post_messages"></audio>
                    </span>
                    <span v-if="item.m_type == 'video'" class="span1-content">
                      <div class="video" style="height:140px;width:200px;">
                        <video
                          id="video"
                          style="height:140px;width:200px;object-fit:fill"
                          controls="controls"
                          preload="auto"
                          :src="attach_url+item.m_post_messages"
                          poster="attach_url+videoImg"
                        ></video>
                      </div>
                    </span>
                    <van-image
                      v-if="item.m_type == 'image'"
                      width="100"
                      class="err-image-img"
                      :src="attach_url+item.m_post_messages"
                      @click.stop="showImage(attach_url+item.m_post_messages)"
                    />
                  </div>
                </van-col>
              </div>
            </van-row>
          </div>
        </template>
        <van-popup
          v-model="show1"
          class="overly"
          :overlay-style="{backgroundColor:'transparent' }"
          :style="{width:'120px'}"
        >
          <div @click="delmsg(m_id, m_from_user_id,create_time)">
            <p v-if="new Date().getTime() - create_time * 1000 < 120000">撤回</p>
            <p v-else>删除</p>
          </div>
          <div @click="Copy(m_id,m_from_user_id,create_time,m_type,m_post_messages)">
            <p v-if="m_type=='text'">复制</p>
            <!-- <p v-else-if="m_type=='video'||m_type=='image'" @click.stop="downImg()">保存到相册</p> -->
          </div>
          <!-- <p @click="choose(m_id)">多选</p> -->
          <p @click="transMsg(m_id,m_from_user_id,create_time,m_type,m_post_messages)">转发</p>
        </van-popup>
      </div>
    </van-pull-refresh>
     <!-- <div class="bottom-bar" v-if="select" style="background-color:#fff;">
      <div class="v1tabbar" style="background-color:#fff;">
        <img class="face" src="../../assets/img/center/transpond.png" alt @click="transmit()" />
      </div>
    </div> -->
    <div class="bottom-bar" v-if="platforms=='app'">
      <div class="v-tabbar">
        <img
          class="face"
          src="../../assets/img/icon/voice.png"
          @click="clickVoice(1)"
          v-if="voice == 0"
        />
        <img class="face" src="../../assets/img/icon/keybd.png" @click="clickVoice(0)" v-else />
        <div v-if="voice==1" class="voice">
          <van-button class="sendc" @click="handleBtnClick" v-show="!recordimg">开始录音</van-button>
          <van-popup v-model="recordimg" class="recordimg" :overlay="false">
            <img src="../../assets/img/center/record.gif" alt />
            <van-count-down
              ref="voiceCountDown"
              millisecond
              :time="voiceLimit"
              :auto-start="false"
              :format="voiceLimit>=60000?'mm:ss:SSS':'ss:SSS'"
              @finish="send_voice"
            />
          </van-popup>
          <van-button class="sendc" @click="cancel_voice" v-show="recordimg">取消录音</van-button>
          <van-button class="sendc" @click="send_voice" v-show="recordimg">发送</van-button>
        </div>
        <van-field
          v-else
          class="sendc"
          v-model="content"
          :clearable="true"
          border
          placeholder="请输入内容"
          type="textarea"
          autosize
          @click="showOf()"
          @focus="closeOther()" 
        />
        <!-- @click-input="keyboard()" -->
        <img class="face" src="../../assets/img/icon/face.png" alt @click="showface()" />
        <van-button
          class="send"
          v-if="content!=''"
          :style="{ width: '20%'}"
          type="info"
          @click="sendmsg"
        >发送</van-button>
        <img class="face" v-else src="../../assets/img/icon/plus.png" @click="showFunction()" />
      </div>
      <div v-show="faceshow" class="faceshow">
        <van-icon
          size="8"
          v-for="item in OwOlist"
          :key="item+''"
          :name="getOwOlistUrl()+item.url"
          @click="selectOwO(item.title)"
        />
      </div>
      <div class="functionshow" v-show="functionshow">
        <button class="f-button">
          <van-icon size="35" name="photograph" @click="photo()" />
        </button>
        <van-uploader capture :after-read="onSend" :before-read="beforeRead" accept="image/*">
          <button class="f-button">
            <van-icon size="35" name="photo" @click="O()" />
          </button>
        </van-uploader>
        <button class="f1-button">
          <input
            ref="uploadVideo"
            type="file"
            @change="sendVideo"
            accept="video/*"
            id="fileUpload"
            capture="camcorder"
            style="opacity:0; width:35px;"
          />
        </button>
      </div>
    </div>
    <div class="bottom-bar" v-else>
      <div class="v-tabbar">
        <van-field
          type="textarea"
          class="sendc"
          v-model="content"
          :clearable="true"
          :autosize="true"
          border
          placeholder="请输入内容"
          @click="showOf()"
          @focus="closeOther()"
          @keyup.ctrl.enter.native="onTextareaKeyDown()"
        />
        <img class="face" src="../../assets/img/icon/face.png" alt @click="showface()" />
        <van-button
          class="send"
          v-if="content!=''"
          :style="{ width: '20%'}"
          type="info"
          @click="sendmsg"
        >发送</van-button>
        <img class="face" v-else src="../../assets/img/icon/plus.png" @click="showFunction()" />
      </div>
      <div v-show="faceshow" class="faceshow">
        <van-icon
          size="8"
          v-for="item in OwOlist"
          :key="item+''"
          :name="getOwOlistUrl()+item.url"
          @click="selectOwO(item.title)"
        />
      </div>
      <div class="functionshow" v-show="functionshow">
        <button class="f-button">
          <van-icon size="35" name="photo" @click="photo()" />
        </button>
        <van-uploader capture :after-read="onSend" :before-read="beforeRead" accept="image/*">
          <button class="f-button">
            <van-icon size="35" name="photograph" @click="O()" />
          </button>
        </van-uploader>
        <button class="f1-button">
          <input
            ref="uploadVideo"
            type="file"
            @change="sendVideo"
            accept="video/*"
            id="fileUpload"
            capture="camcorder"
            style="opacity:0; width:35px;"
          />
        </button>
      </div>
    </div>
    <van-popup
      v-model="photoShow"
      closeable
      close-icon="close"
      position="bottom"
      :style="{ height: '45%' }"
    >
      <van-tabbar :fixed="false">
        <van-button type="primary" @click="filesSend">发送</van-button>
      </van-tabbar>
      <van-uploader
        v-model="fileList"
        :after-read="onRead"
        :before-read="beforeRead"
        accept="image/*"
        :style="{'margin-top': '15%'}"
        :max-count="1"
      />
    </van-popup>
    <!-- 群聊消息声音提醒 -->
    <audio controls="controls" hidden src="./static/mp3/msg.wav" ref="audios"></audio>
    <van-dialog
      v-model="showImgDialog"
      :showConfirmButton="false"
      :closeOnClickOverlay="true"
      class="img_dialog"
      @click="showImgDialog=false"
    >
      <img :src="image_url" style="width:100%;" @click="showImgDialog=false" @touchstart="start1()" />
    </van-dialog>
  </div>
</template>

<script>
import { utf16toEntities, chkImgType } from "@/utils/common.js";
import {
  OwOlistUrl,
  analyzeEmoji,
  emojiList,
  compUploadImg
} from "@/utils/chat.js";
import Recorderx, { ENCODE_TYPE } from "recorderx";
const rc = new Recorderx();
export default {
  name: "OnlineService",
  data() {
    return {
      photoShow: false,
      recordimg: false,
      faceshow: false,
      show1: false,
      functionshow: false,
      textshow: false,
      popupVisible2: false,
      news_img: false,
      voice: false,
      active: 0,
      title: "在线客服",
      friend_id: "",
      fileList: [], // 回显图片
      imagePath: [], // 上传图片路径
      data: [],
      totalTime: 30,
      reg: /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/,
      titleList: [{ name: "表情" }, { name: "多媒体" }],
      chatMessage: [],
      footHeight: 60,
      show: false,
      content: "",
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
      attach_url: this.Conf.serverPre,
      OwOlist: emojiList,
      Socket: "",
      lockReconnect: false, //是否真正建立连接
      timeout: 20 * 1000, //20秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时,
      voiceStartTime: null,
      refresh_more_time: 0,
      voiceLimit: 30000,
      filesizelimit: 10485760,
      minMsgId: 0,
      isloading: false,
      showImgDialog: false,
      image_url: "",
      platforms: null,
      showVideoDialog: false,
      video_url: "",
      Loop: 0,
      reloadMoreMsgFlag: false,
      img: "",
      flag: true,
      videoImg: "",
      imurl: "",
      videoFlag: false,
      videoProgress: 0,
      m_id: "",
      m_from_user_id: "",
      create_time: "",
      connected: false,
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      chatList: [],
      maxMsgId: 0,
      WindValue: localStorage.getItem("fontsize")
        ? parseInt(localStorage.getItem("fontsize"))
        : 12,
      status: 0,
      rannumber: 1,
      latestInterTmer: false,
      longClick: 0,
      timeOutEvent: 0,
      m_post_messages: "",
      m_type: "",
      transfer:false,
      transtat:"",
      msgshowlist:JSON.parse(localStorage.getItem("msgshowLists")),
	  videoLengthLimit:20,
	  videoSizeLimit:10 * 1024 * 1024
    };
  },
  created() {
	this.getStateConfigs();
    this.getServiceInfo();
    setTimeout(() => {
      this.chkSocketState();
    }, 2000);
    this.loadData();
    this.platforms = this.Conf.platform;
  },
  mounted() {

    if (this.$refs.ref_content.scrollHeight > 0) {
      this.$nextTick(() => {
        this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
      });
    }
  },
  computed: {
    // 滚动区高度
    // (业务需求：手机屏幕高度减去头部标题和底部tabbar的高度，当然这2个高度也是可以动态获取的)
    scrollerHeight: function() {
      return window.innerHeight - 40 - this.footHeight + "px";
    }
  },
  // watch:{
  //   scrollerHeight
     
  // },
  methods: {
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
				if (confs.duration) {
					this.voiceLimit = parseInt(confs.duration.values) * 1000;
				}
				if (confs.fileSize) {
					this.filesizelimit = parseInt(confs.fileSize.values);
				}
				if (confs.videoLength){
					this.videoLengthLimit = parseInt(confs.videoLength.values);
				}
				if (confs.videoSize){
					this.videoSizeLimit = parseInt(confs.videoSize.values);
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
    // 滚动至聊天底部
    scrollToBottom() {
      // 滚动
      if (this.$refs.ref_content.scrollHeight > 0) {
        this.$nextTick(() => {
          this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
        });
      }
    },
    photo() {
      this.photoShow = true;
    },
    selectOption(m_id, m_from_user_id, create_time, m_type, m_post_messages) {
      this.m_id = m_id;
      this.m_from_user_id = m_from_user_id;
      this.create_time = create_time;
      this.m_post_messages = m_post_messages;
      this.m_type = m_type;
      this.show1 = true;
    },
    delmsg(m_id, m_from_user_id, create_time) {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      // this.show1 = true;
      this.show1 = false;
      if (new Date().getTime() - create_time * 1000 < 120000) {
        if (m_from_user_id == this.u_id) {
          this.$dialog
            .confirm({
              title: "撤回消息",
              message: "确定撤回该条消息吗？"
            })
            .then(() => {
              var params = {
                friend_id: this.friend_id,
                state: 1,
                m_id: m_id,
                u_id: this.u_id,
                token: this.token,
                num: Math.random()
              };
              var url = this.Conf.serverUrl + "Service/deleteOneMsg";
              this.$axios
                .post(url, this.$qs.stringify(params))
                .then(response => {
                  switch (response.data.code) {
                    case 200:
                      var data = {
                        m_id: m_id,
                        friend_id: this.friend_id,
                        u_id: this.u_id,
                        mk: 8
                      };
                      this.websocket.ws.send(JSON.stringify(data));
                      this.websocket.ws.onmessage = this.getMessage;
                      break;
                    case 40001:
                      this.$toast.fail("撤回失败！");
                      break;
                  }
                })
                .catch(error => {});
            })
            .catch(() => {});
        }
        return false;
      } else {
        this.$dialog
          .confirm({
            title: "删除消息",
            message: "确认删除该条消息吗？"
          })
          .then(() => {
            var params = {
              m_id: m_id,
              type: 1,
              u_id: this.u_id,
              token: this.token,
              num: Math.random()
            };
            var url = this.Conf.serverUrl + "Service/delMsg";
            this.$axios
              .post(url, this.$qs.stringify(params))
              .then(response => {
                switch (response.data.code) {
                  case 200:
                    var data = {
                      m_id: m_id,
                      friend_id: this.friend_id,
                      u_id: this.u_id,
                      mk: 9
                    };
                    this.websocket.ws.send(JSON.stringify(data));
                    this.websocket.ws.onmessage = this.getMessage;
                    break;
                  case 40001:
                    this.$toast.fail("删除失败！");
                    break;
                }
              })
              .catch(error => {});
          })
          .catch(() => {});
        return false;
      }
    },
    getServiceInfo(){
      var params = {
        u_id: this.u_id,
        token: this.token,
        u_platform: this.userinfo.u_platform
      }
      var url = this.Conf.serverUrl + "Service/getServiceInfo";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          switch(response.data.code){
            case 200:
              this.friend_id = response.data.friend_id;
              break;
            case 40001:
              this.$dialog
            .alert({
              message: response.data.msg
            })
            .then(() => {});
              break;  
          }
         
        })
        .catch(error => {});
    },
    loadData() {
      var params = {
        u_id: this.u_id,
        friend_id: this.friend_id,
        token: this.token,
        msg_id: 0,
        max_id: 0
      };
      if (this.status == 1) {
        params.msg_id = this.minMsgId;
      } else if (this.status == 2) {
        params.max_id = this.maxMsgId;
      }
      var url = this.Conf.serverUrl + "Service/chatroom";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          if (response.data.code == 200) {
            if (response.data.mk == 1) {
              for (var i in response.data.chatroomMsg) {
                this.chatMessage.push(response.data.chatroomMsg[i]);
                this.maxMsgId = response.data.chatroomMsg[i].m_id;
              }
            } else {
              for (var i in response.data.chatroomMsg) {
                this.chatMessage.unshift(response.data.chatroomMsg[i]);
                if (i == 0 && !this.maxMsgId) {
                  this.maxMsgId = response.data.chatroomMsg[i].m_id;
                }
                this.minMsgId = response.data.chatroomMsg[i].m_id;
              }
            }
            this.scrollToBottom();
            this.reloadMoreMsgFlag = false;
          }
         
        })
        .catch(error => {});
    },
    reloadMoreMsg() {
      this.status = 1;
      this.footHeight = 60;
      if (!this.reloadMoreMsgFlag) {
        this.reloadMoreMsgFlag = true;
        setTimeout(() => {
          this.loadData();
          this.isloading = false;
        }, 2000);
      } else {
        this.isloading = false;
      }
      return true;
    },
    showface() {
      this.faceshow = true;
      this.functionshow = false;
      this.popupVisible2 = true;
      this.clickVoice(0);
      this.footHeight = 260;
      if (this.$refs.ref_content.scrollHeight > 0) {
        this.$nextTick(() => {
          this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
        });
      }
    },
    analyzeEmoji(cont) {
      return analyzeEmoji(cont);
    },
    onClickLeft() {
      // 返回
      this.$router.push({
        path: "/Service"
      });

      var params = {
        u_id: this.u_id,
        token: this.token,
        num: Math.random()
      };
      var url = this.Conf.serverUrl + "Service/clearTempMId";
      this.$axios
        .post(url, this.$qs.stringify(params))
        .then(response => {
          // console.log(response.data.msg);
        })
        .catch(error => {});
    },
    // 监听socket消息回调
    getMessage(msg) {
      var that = this;
      var data = JSON.parse(msg.data);
      switch (data.status) {
        case 1:
        case 2:
             // 重新连接socket fd改变，客户端与服务端token相等时，不退出登入
          if (this.token == data.token) {
            return;
          }
          // 用户在别处登录，客服端与服务端token不相等时
          // 客户端token 与 后台token不相等时，退出登入
          window.localStorage.clear();
          that.$dialog
            .alert({
              message: data.message
            })
            .then(() => {
              that.$router.push({ path: "/login" });
            });
          break;
        case 3:
          if (data.tag == "one" && data.message == "deleteOk") {
            this.$refs["ref_msg_" + data.m_id][0].innerHTML = "撤回了一条消息";
            this.$refs["ref_msg_" + data.m_id][0].style.width = "100%";
            this.$refs["ref_msg_" + data.m_id][0].style.fontSize = "12px";
            this.$refs["ref_msg_" + data.m_id][0].style.color = "#969799";
            this.$refs["ref_msg_" + data.m_id][0].style.lineHeight = "40px";

            return;
          } else if (data.tag == "del" && data.message == "deleteOk") {
            this.$refs["ref_msg_1" + data.m_id][0].innerHTML = "";
            return;
          }
          if (data.data.m_type == "alert") {
            this.$toast(data.data.m_post_messages);
            return;
          }
          // 只push到当前聊天
          if (
            (data.u_id == that.u_id && data.friend_id == that.friend_id) ||
            (data.u_id == that.friend_id && data.friend_id == that.u_id)
          ) {
            if(this.transtat != 1){
              that.chatMessage.push(data.data);
            }
            this.transtat="";
            setTimeout(_ => {
              if (this.$refs.ref_content.scrollHeight > 0) {
                this.$nextTick(() => {
                  this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
                });
              }
            }, 500);
          }
          if (data.tag == "group" && data.data.gm_from_id != that.u_id) {
            // console.log("播放群聊声音,群消息：" + data.data);
            // 记录群聊未读消息数
            var groupunread = [];
            var groupunreads = JSON.parse(localStorage.getItem("groupUnread"));
            if (!groupunreads) {
              var read = {
                group_id: data.ug_id,
                unreadNumber: 1
              };
              groupunread.push(read);
              localStorage.setItem("groupUnread", JSON.stringify(groupunread));
            } else {
              var array = [];
              groupunreads.forEach(element => {
                if (element.group_id == data.ug_id) {
                  ++element.unreadNumber;
                  localStorage.setItem(
                    "groupUnread",
                    JSON.stringify(groupunreads)
                  );
                }
                array.push(element.group_id);
              });
              if (array.indexOf(data.ug_id) <= -1) {
                var r = {
                  group_id: data.ug_id,
                  unreadNumber: 1
                };
                groupunreads.push(r);
                localStorage.setItem(
                  "groupUnread",
                  JSON.stringify(groupunreads)
                );
              }
            }
            //播放声音
            var groupNoDistrrbing = localStorage.getItem(
              data.ug_id + "groupNoDistrrbing"
            );
            if (that.u_id != data.data.gm_from_id && groupNoDistrrbing != 1) {
              // console.log("当前chat播放音乐用户id：" + that.u_id);
              that.$refs.audios.currentTime = 0; //从头开始播放提示音
              that.$refs.audios.play(); //播放
              // console.log("-----------------------------");
            }
          }
          // 未读消息汇总
          var num = 0;
          var number = 0;
          var arr = JSON.parse(localStorage.getItem("unread"));
          if (arr) {
            arr.forEach(element => {
              num += element.unreadNumber;
            });
          }
          var array = JSON.parse(localStorage.getItem("groupUnread"));
          if (array) {
            array.forEach(element => {
              number += element.unreadNumber;
            });
          }
          localStorage.setItem("countUnread", num + number);
          break;
        case 4:
          this.maxMsgId = data.m_id;
          break;
        case 5: // 切换客服 替换原客服id
          if(data.m_from_user_id == this.friend_id && data.m_to_user_id == this.u_id){
            this.friend_id = data.service_id;
            this.$dialog
            .alert({
              message: data.message
            })
            .then(() => {});
          }
         break;  
          case 6:
            if(data.tag == 'like'){ 
            //记录点赞未读数
            var unreadlike = [];
            var unreadlikes = JSON.parse(localStorage.getItem("unreadlike"));
            if (!unreadlikes) {
              // 未读点赞是空的就新增
              var read = {
                likeId: data.userinfo.u_id,
                unreadNumber: 1
              };
              unreadlike.push(read);
              localStorage.setItem("unreadlike", JSON.stringify(unreadlike));
            } else {
              // 未读点赞不为空就累加
              var arr = [];
              unreadlikes.forEach((element) => {
                if (element.likeId == data.userinfo.u_id) {
                   ++element.unreadNumber;
                  localStorage.setItem("unreadlike", JSON.stringify(unreadlikes));
                }
                arr.push(element.likeId);
              });
              // 发送者id不在记录里就新增进去
              if (arr.indexOf(data.userinfo.u_id) <= -1) {
                var r = {
                  likeId: data.userinfo.u_id,
                  unreadNumber: 1,
                };
                unreadlikes.push(r);
                localStorage.setItem("unreadlike", JSON.stringify(unreadlikes));
              }
             }
            var newmsgList=[];
            newmsgList.push(data.userinfo);
            localStorage.setItem("newmsgList", JSON.stringify(newmsgList));
            //获取新消息列表
            that.msgshowList.unshift(data);
            localStorage.setItem("msgshowLists", JSON.stringify(that.msgshowList));
            } 
           that.countread();
           break;
          case 7:
           // 记录评论未读数
            var unreadcomment = [];
            var unreadcomments = JSON.parse(localStorage.getItem("unreadcomment"));
            if (!unreadcomments) {
              var read = {
                commentId: data.comment.u_id,
                unreadNumber: 1
              };
              unreadcomment.push(read);
              localStorage.setItem("unreadcomment", JSON.stringify(unreadcomment));
            } else {
              var array = [];
              unreadcomments.forEach(element => {
                if (element.commentId== data.comment.u_id) {
                  ++element.unreadNumber;
           localStorage.setItem("unreadcomment", JSON.stringify(unreadcomments));
                }
                array.push(element.commentId);
              });
              if (array.indexOf(data.comment.u_id) <= -1) {
                var r = {
                  commentId: data.comment.u_id,
                  unreadNumber: 1
                };
                unreadcomments.push(r);
                localStorage.setItem("unreadcomment", JSON.stringify(unreadcomments));
              }
            }
            var newmsgList=[];
            newmsgList.push(data.comment.user);
            localStorage.setItem("newmsgList", JSON.stringify(newmsgList));
            //获取新消息列表
            that.msgshowList.unshift(data);
            localStorage.setItem("msgshowLists", JSON.stringify(that.msgshowList));
            that.countread();
          break;
        }
    },
     countread(){
       // 未读点赞和评论汇总
           var num = 0;
           var number = 0;
           var arr = JSON.parse(localStorage.getItem("unreadlike"));
           if (arr) {
            arr.forEach((element) => {
              num += element.unreadNumber;
            });
          }
          var array = JSON.parse(localStorage.getItem("unreadcomment"));
          if (array) {
            array.forEach((element) => {
              number += element.unreadNumber;
            });
          }
          localStorage.setItem("circlecountUnread", num + number);
          this.circlecountUnread = JSON.parse(localStorage.getItem("circlecountUnread")) 
    },
    chkSocketState() {
      if ( this.websocket && this.websocket.ws && this.websocket.ws.readyState == 1 ) {
        this.connected = true;
        // 监听socket连接
        this.websocket.ws.onopen = this.open;
        // 监听socket错误信息
        this.websocket.ws.onerror = this.error;
        // 监听消息回调
        this.websocket.ws.onmessage = this.getMessage;
        // 监听连接关闭
        this.websocket.ws.onclose = this.close;
        this.start();
      } else {
        this.connected = false;
        this.reconnect();
      }
      return this.connected;
    },
    // 发送消息
    sendmsg() {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      if (
        this.content.trim() == "" ||
        this.content == null ||
        typeof this.content == "undefined"
      ) {
        return this.$toast("输入不能为空！");
      } else {
       
        var data = {
          message: utf16toEntities(this.content),
          friend_id: this.friend_id,
          u_id: this.u_id,
          mk: 5,
          type: "text",
          u_headportrait: this.userinfo["u_headportrait"],
          m_id: this.u_id + "_" + this.rannumber
        };
        ++this.rannumber;
        this.websocket.ws.send(JSON.stringify(data));
        this.content = "";
        setTimeout(_ => {
          if (this.$refs.ref_content.scrollHeight > 0) {
            this.$nextTick(() => {
              this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
            });
          }
        }, 500);
      }
    },
    randomWord(randomFlag, min, max){
      // 生成 3 - 32 位随即字符串
      //randomWord(true,3,32);  //  例如：olyOXUF5oDsuMmXl3Mi48
      //  生成 32 位随机字符串
      //randomWord(false,32);   //  例如：fjpnWj29Bb8boiXbLeDF0nxkR4aYcLRl
      var str = "",
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

      // 随机产生
      if(randomFlag){
        range = Math.round(Math.random() * (max-min)) + min;
      }
      for(var i=0; i<range; i++){
       var pos = Math.round(Math.random() * (arr.length-1));
        str += arr[pos];
      }
      return str;
    },
    sum(m,n){
      //this.sum(1,100)
  　　var num = Math.floor(Math.random()*(m - n) + n);
  　　return num;
    },
    // socket连接，在此页面做重连用，初始化连接在登录页面
    localSocket() {
      let that = this;
      if ("WebSocket" in window) {
        console.log("您的浏览器支持 WebSocket!");
        var u_id = localStorage.getItem("u_id");
        var token = localStorage.getItem(u_id + "token");
        var ws_url = localStorage.getItem("ws_url");

        if (u_id && token && ws_url) {
          // 实例化websocket连接
          this.Socket = new WebSocket(
            ws_url + "?uid=" + u_id + "&token=" + token
          );
          // 注册进全局
          this.websocket.setWs(this.Socket);
          // 监听socket连接
          this.websocket.ws.onopen = this.open;
          // 监听socket错误信息
          this.websocket.ws.onerror = this.error;
          // 监听消息回调
          this.websocket.ws.onmessage = this.getMessage;
          // 监听连接关闭
          this.websocket.ws.onclose = this.close;
          console.log("chatroom", "连接websocket");
        } else {
          // // 浏览器不支持 WebSocket
          // console.log("您的浏览器不支持 WebSocket!");
        }
      }
    },
    //重新连接
    reconnect() {
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        //新连接
        console.log("重新连接");
        that.localSocket();
        that.loadData();
        that.lockReconnect = false;
      }, 2000);
    },
    start() {
      var self = this;
      clearInterval(window.timer);
      self.websocket.ws.send("heartCheck");
      window.timer = setInterval(function() {
        if (self.websocket.ws.readyState == 1) {
          console.log("OnlineService", "发送心跳");
          self.websocket.ws.send("heartCheck");
        } else {
          this.loadLatestMsg();
          console.log("OnlineService", "连接已经关闭");
          var u_id = localStorage.getItem("u_id");
          var token = localStorage.getItem(u_id + "token");
          var ws_url = localStorage.getItem("ws_url");
          if (u_id && token && ws_url) {
            this.reconnect();
          }
        }
      }, 20000);
    },
    // 监听socket连接
    open() {
      //开启心跳
      this.status = 2;
      this.loadData();
      console.log("OnlineService", "开启心跳");
      this.connected = true;
      if (this.latestInterTmer) {
        clearInterval(this.latestInterTmer);
      }
      this.start();
      console.log('OnlineService',"连接成功");
    },
    // 监听socket连接错误
    error() {
     
      //重连
      this.reconnect();
      console.log('OnlineService',"错误重新连接");
    },
    close(e) {
      this.loadLatestMsg();
      //重连
      var u_id = localStorage.getItem("u_id");
      var token = localStorage.getItem(u_id + "token");
      var ws_url = localStorage.getItem("ws_url");
      if (u_id && token && ws_url) {
        this.reconnect();
        console.log(
          "OnlineService",
          "socket关闭重连" + e.code + " " + e.reason + " " + e.wasClean
        );
      }
    },
    onTextareaKeyDown() {
      if (event.keyCode == 13) {
        //如果按的是enter键 13是enter
        event.preventDefault(); //禁止默认事件（默认是换行）
        this.sendmsg(); //执行发送动作
      }
    },
    loadLatestMsg() {
      this.status = 2;
      if (this.latestInterTmer) {
        clearInterval(this.latestInterTmer);
      }
      this.latestInterTmer = setInterval(() => {
        this.loadData();
      }, 3000);
    },
    headPortrait(id) {
      this.$router.push({
        name: "UserInfo",
        query: {
          friend_id: id,
          url: "Chatroom",
          active: 0
        }
      });
    },
    isUrl(val) {
      var reg = /([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|[wW]{3}.|[wW][aA][pP].|[fF][tT][pP].|[fF][iI][lL][eE].)[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
      return reg.test(val);
    },
    CheckUrl(m_post_messages) {
      var reg = /([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/|[wW]{3}.|[wW][aA][pP].|[fF][tT][pP].|[fF][iI][lL][eE].)[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
      if (!reg.test(m_post_messages)) {
      } else {
        // alert("这个是网址");
        if (window.plus) {
          plus.runtime.openURL(m_post_messages);
        } else {
          window.open(m_post_messages);
        }
        return;
      }
    },
    // 弹出表情包
    showPopup(re) {
      this.show = re;
    },
    showFunction() {
      this.functionshow = true;
      this.faceshow = false;
      this.clickVoice(0);
      this.footHeight = 140;
      if (this.$refs.ref_content.scrollHeight > 0) {
        this.$nextTick(() => {
          this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
        });
      }
    },
    // 获取表情包url前缀
    getOwOlistUrl() {
      return OwOlistUrl;
    },
    // 选择表情包
    selectOwO(title) {
      this.content += title;
    },
    showOf() {
      this.show = false;
      // this.footHeight = 260;
      if (this.$refs.ref_content.scrollHeight > 0) {
        this.$nextTick(() => {
          this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
        });
      }
    },
    // keyboard(){
    //     this.footHeight = 260;
    //   if (this.$refs.ref_content.scrollHeight > 0) {
    //     this.$nextTick(() => {
    //       this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
    //     });
    //   }
    // },
    closeOther() {
      this.functionshow = false;
      this.faceshow = false;
      this.footHeight = 60;
      if (this.$refs.ref_content.scrollHeight > 0) {
        this.$nextTick(() => {
          this.$refs.ref_content.scrollTop = this.$refs.ref_content.scrollHeight;
        });
      }
    },
    // 切换语音软键盘
    clickVoice(e) {
      this.voice = e;
      if (e == 1) {
        this.show = false;
        this.faceshow = false;
        this.functionshow = false;
      }
      this.footHeight = 60;
    },
    //录制语音
    handleBtnClick() {
      let that = this;
      rc.start()
        .then(() => {
          that.voiceStartTime = new Date().getTime();
          that.recordimg = true;
          that.$refs.voiceCountDown.reset();
          that.$refs.voiceCountDown.start();
        })
        .catch(error => {
          that.recordimg = false;
          this.$toast("获取麦克风失败,不能录音哦");
        });
    },
    cancel_voice() {
      this.recordimg = false;
      // rc.pause();
      rc.clear();
    },
    // 发送语音
    send_voice() {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      this.recordimg = false;
      rc.pause();
      let voiceTimes = new Date().getTime() - this.voiceStartTime;
      // alert("没有音频资源");
      let that = this;
      var wav = rc.getRecord({
        encodeTo: ENCODE_TYPE.WAV,
        compressible: true
      });
      var formData = new window.FormData();
      formData.append("audio", wav, Date.parse(new Date()) + ".wav");
      let headers = { "Content-Type": "multipart/form-data" };
      //  this.$axios.defaults.withCredentials = true;
      var url =
        this.Conf.serverUrl + "Chat/uploadAudio" + "?num=" + Math.random();
      this.$axios
        .post(url, formData, headers)
        .then(response => {
          if (response.data.audioUrl) {
            var data = {
              message: response.data.audioUrl,
              friend_id: that.friend_id,
              u_id: that.u_id,
              mk: 5,
              type: "audio",
              duration: voiceTimes,
              u_headportrait: that.userinfo["u_headportrait"],
              m_id: that.u_id + "_" + that.rannumber
            };
            ++that.rannumber;
            this.websocket.ws.send(JSON.stringify(data));
            this.websocket.ws.onmessage = this.getMessage;
          }
          rc.clear();
        })
        .catch(err => {});
    },
    //上传视频
    sendVideo() {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      var that = this;
      let filesize = this.videoSizeLimit;
      let filelength = this.videoLengthLimit;
      var file = that.$refs.uploadVideo.files[0];
      var formData = new FormData();
      if (file.size > filesize) {
        that.$toast("视频不能超过" + filesize / (1024 * 1024) + "M");
        return;
      } else if (file.length > filelength) {
        that.$toast("视频不能超过" + filelength + "s");
        return;
      } else {
        that.$toast("请稍候...");
        formData.append("video", file);
        let headers = { "Content-Type": "multipart/form-data" };
        that.videoFlag = true;
        var url = this.Conf.serverUrl + "Chat/uploadVideo";
        that.$axios
          .post(url, formData, headers)
          .then(response => {
            that.videoFlag = false;
            // that.videoImg = response.data.videoImgUrl;
            if (response.data.videoUrl) {
              var userInfo = JSON.parse(localStorage.getItem('userInfo'));
              var data = {
                message: response.data.videoUrl,
                duration: response.data.duration,
                friend_id: that.friend_id,
                u_id: that.u_id,
                mk: 5,
                type: "video",
                u_headportrait: that.userinfo["u_headportrait"],
                m_id: that.u_id + "_" + that.rannumber
              };
              ++that.ranmuber;
              that.websocket.ws.send(JSON.stringify(data));
              that.websocket.ws.onmessage = that.getMessage;
            }
          })
          .catch(err => {});
      }
    },
    // 上传之前检测图片类似返回true和false会影响到onRead函数
    beforeRead(file) {
      return chkImgType(file);
    },
    // 发送图片
    filesSend() {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      if (
        this.data.message.trim() == "" ||
        this.data.message == null ||
        typeof this.data.message == "undefined"
      ) {
        return this.$toast("不能为空！");
      } else {
        this.$toast("请稍候...");
        var url =
          this.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
        this.$axios
          .post(url, this.$qs.stringify(this.data))
          .then(response => {
            if (response.data.imageUrl) {
              this.data.message = response.data.imageUrl;
              this.data.duration = response.data.duration;
              // 先执行上传保存图片，返回图片保存的路径，然后再发送socket消息，发送的是图片路径。
              this.websocket.ws.send(JSON.stringify(this.data));
              this.websocket.ws.onmessage = this.getMessage;
              this.data = {};
              this.fileList = [];
            } else if (response.data.msg) {
              this.$toast(response.data.msg);
            }
          })
          .catch(error => {});
      }
      this.photoShow = false;
    },
    // 拍照上传图片
    onRead(file) {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      let that = this;
      that.$toast("请稍候...");
      compUploadImg(file, function(f) {
        that.data = {
          message: file.content,
          friend_id: that.friend_id,
          u_id: that.u_id,
          mk: 5,
          type: "image",
          u_headportrait: that.userinfo["u_headportrait"],
          m_id: that.u_id + "_" + that.rannumber
        };
        ++that.rannumber;
      });
    },
    // 上传图片
    async onSend(file) {
      if (!this.chkSocketState()) {
        return this.$toast("连接马上建立，请稍候...！");
      }
      let that = this;
      // 小于1MB的图片都缩小像素上传
      compUploadImg(file, function(f) {
        that.$toast("请稍候...");
        let data = {};
        data.message = file.content;
        data.friend_id = that.friend_id;
        data.u_id = that.u_id;
        data.mk = 5;
        data.type = "image";
        data.u_headportrait = that.userinfo["u_headportrait"];
        data.m_id = that.u_id + "_" + that.rannumber;
        ++that.rannumber;
        var url =
          that.Conf.serverUrl + "Chat/uploadImg" + "?num=" + Math.random();
        setTimeout(() => {
          that.$axios
            .post(url, that.$qs.stringify(data))
            .then(response => {
              if (response.data.imageUrl) {
                data.message = response.data.imageUrl;
                data.duration = response.data.duration;
                that.websocket.ws.send(JSON.stringify(data));
                that.websocket.ws.onmessage = that.getMessage;
              } else if (response.data.msg) {
                that.$toast(response.data.msg);
              }
            })
            .catch(error => {});
        }, 500);
      });
    },
    showImage(img) {
      this.showImgDialog = true;
      this.image_url = img;
    },
    start1() {
      var that = this;
      this.longClick = 0;
      this.timeOutEvent = setTimeout(function() {
        that.longClick = 1;
        that.downImg();
      }, 2000);
    },
    // 保存图片
    downImg() {
      if (!window.plus) return;
      var self = this;
      plus.gallery.save(
        this.image_url,
        function() {
          return self.$toast("图片已保存到相册!");
        },
        function() {
          return self.$toast("保存失败，请重试!");
        }
      );
    },
    //复制信息
    Copy(m_id, m_from_user_id, create_time, m_type, m_post_messages) {
      // console.log("2222", m_id, m_from_user_id, create_time, m_post_messages);
      let url = m_post_messages;
      let oInput = document.createElement("input");
      oInput.value = m_post_messages;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      // console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.remove();
    },
    transMsg(m_id,m_from_user_id,create_time,m_type,m_post_messages){
        this.$router.push({
        path: "/NewChat",
        query:{
          m_post_messages:m_post_messages,
          url: "Chatroom",
        }
      });

    },
  },
  beforeDestroy() {
    if (this.latestInterTmer) {
      clearInterval(this.latestInterTmer);
    }
    if (this.Loop) clearTimeout(this.Loop);
    if (this.timeoutnum) clearTimeout(this.timeoutnum);
    clearInterval(window.timer);
  }
};
</script>
<style lang="less">
.voice {
  width: 70%;
  display: flex;
  .sendc1 {
    width: 100% !important;
    border-radius: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/AddressList/OnlineService.vue